export default __webpack_public_path__ + "static/media/chat_.09a504ac.svg";